export default __webpack_public_path__ + "assets/images/banner_hero-b83c06ff8f67034456ffbba2ae00ee5b.png";